// extracted by mini-css-extract-plugin
export default {"head":"TableHead_head__9BKVw"};